// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '@/assets/css/common.less'
import '@/assets/css/variable.less'
import '@/assets/css/theme/459f75/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import echarts from 'echarts'

import '@/styles/transition.scss' // global css

import store from './store'// 引入store

Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'medium' })
Vue.prototype.$axios = axios // axios不能使用use
Vue.prototype.$echarts = echarts

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store, // 使用store
  components: { App },
  template: '<App/>'
})


// var vue = new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })
export default vue



// WEBPACK FOOTER //
// ./src/main.js